import React from 'react';
import { Container, NumberPeople, HowManyPeople, Sentence, MessageContainer, ButtonContainer, ButtonSign } from './styled/SquareStyled';
import { clickSignButton } from '../actions/action';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

const Square = ({ message, number, clickSignButton }) => {

    return (
        <div>
            <Container>
                <HowManyPeople>
                    <NumberPeople>{`${number}`}</NumberPeople> osób podpisało petycje
                </HowManyPeople>
                <Sentence>
                    Przyjdź z pomocą! Podpisz petycję!
                </Sentence>
                <MessageContainer>{`${message}`}</MessageContainer>
                <ButtonContainer>
                    <Link to="/login">
                        <ButtonSign onClick={() => clickSignButton()}>PODPISZ</ButtonSign>
                    </Link>
                </ButtonContainer>
            </Container>
        </div>
    )
}

const mapDispatchToProps = {
    clickSignButton
}
export default connect(null, mapDispatchToProps)(Square);